import { Block, Text } from '@snowflake/core-ui';
import { InfoList } from './InfoList';
import React from 'react';
import { SubtitleHeading } from './SubtitleHeading';
import { useSignupPageContext } from '../../pages/SignupContext';

const DefaultLeftContent = () => {
  const { renderingOptions } = useSignupPageContext();

  return (
    <Block
      className="trial-left-container"
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <SubtitleHeading />
      <InfoList />
      <Text
        weight="semi-bold"
        style={{ color: '#29B5E8', fontSize: '20px', lineHeight: '30px' }}
        marginBottom="28px"
      >
        {renderingOptions.cardMarketingTitle}
      </Text>
    </Block>
  );
};

export default DefaultLeftContent;
